import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const BreadCrumbs = ({}: { page: string }) => {
  const navigate = useNavigate();
  const { storeType, storeId } = useParams<{ storeType: string; storeId: string }>();
  return (
    <div className="flex items-center gap-2 mb-4">
      <button
        onClick={() => navigate(`/${storeType}/${storeId}/coupons`)}
        className="flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        <ChevronLeft size={16} />
        Back to Coupons
      </button>
    </div>
  );
};

export default BreadCrumbs;
